export default __webpack_public_path__ + "642d0cc.png";